import { axios } from '@Root/API'

export const saveOrder = payload => {
	return axios.put(`additional-field-sort`, payload)
}
